// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '@coa/app/core/config/environmentConfig';
import { config as analyticsCosmoseCn } from '@coa/app/core/config/configs/analytics.cosmose.cn';
import { config as analyticsCosmoseCo } from '@coa/app/core/config/configs/analytics.cosmose.co';
import { config as defaultConfig } from '@coa/app/core/config/configs/default';
import { config as analyticsDevCosmoseCloud } from '@coa/app/core/config/configs/analytics.dev.cosmose.cloud';
import { config as analyticsPreprodCosmoseCn } from '@coa/app/core/config/configs/analytics.preprod.cosmose.cn';
import { config as analyticsPreprodCosmoseCo } from '@coa/app/core/config/configs/analytics.preprod.cosmose.co';
import { config as analyticsPreviewCosmoseCloud } from '@coa/app/core/config/configs/analytics.preview.cosmose.cloud';

export const getConfig = (domain: string): EnvironmentConfig => {
  const configMap = {
    'analytics.cosmose.cn': analyticsCosmoseCn,
    'analytics.cosmose.co': analyticsCosmoseCo,
    'analytics.dev.cosmose.cloud': analyticsDevCosmoseCloud,
    'analytics.preprod.cosmose.cn': analyticsPreprodCosmoseCn,
    'analytics.preprod.cosmose.co': analyticsPreprodCosmoseCo,
    'analytics.preview.cosmose.cloud': analyticsPreviewCosmoseCloud,
  };

  return configMap[domain] ?? defaultConfig;
};
